import type { IconSvgObject } from './types';

const CallIcon: IconSvgObject = [
  ["path", { d: "M13.4892 19.023L16.4839 16.0284C16.7887 15.7236 17.2544 15.647 17.6556 15.8046C18.2138 16.0238 19.0694 16.3105 20.002 16.4444C20.5495 16.523 21 16.9678 21 17.5209V20.0245C21 20.5775 20.5509 21.0288 19.9986 20.9986C10.8404 20.4971 3.50289 13.1596 3.00144 4.00139C2.9712 3.44914 3.42245 3 3.97553 3H6.47913C7.03221 3 7.47697 3.45051 7.55558 3.99797C7.6895 4.93061 7.97621 5.78617 8.19544 6.34436C8.35302 6.74557 8.27642 7.21135 7.97162 7.51614L4.97697 10.5108", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default CallIcon;
